/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_zoi_card__error = /** @type {(inputs: {}) => string} */ () => {
	return `Die Sehenswürdigkeiten konnten nicht angezeigt werden.`
};

const en_zoi_card__error = /** @type {(inputs: {}) => string} */ () => {
	return `Points of interest couldn't be displayed.`
};

const es_zoi_card__error = /** @type {(inputs: {}) => string} */ () => {
	return `No se pudieron mostrar los puntos de interés.`
};

const fr_zoi_card__error = /** @type {(inputs: {}) => string} */ () => {
	return `Les points d’intérêt n’ont pas pu être affichés.`
};

const it_zoi_card__error = /** @type {(inputs: {}) => string} */ () => {
	return `Impossibile visualizzare i punti di interesse.`
};

const nl_zoi_card__error = /** @type {(inputs: {}) => string} */ () => {
	return `Nuttige plaatsen konden niet worden weergegeven.`
};

const pt_zoi_card__error = /** @type {(inputs: {}) => string} */ () => {
	return `Não foi possível visualizar os pontos de interesse.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__error = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.zoi_card__error(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("zoi_card__error", locale)
	if (locale === "de") return de_zoi_card__error(inputs)
	if (locale === "en") return en_zoi_card__error(inputs)
	if (locale === "es") return es_zoi_card__error(inputs)
	if (locale === "fr") return fr_zoi_card__error(inputs)
	if (locale === "it") return it_zoi_card__error(inputs)
	if (locale === "nl") return nl_zoi_card__error(inputs)
	return pt_zoi_card__error(inputs)
};